import { useFormContext, useFieldArray } from "react-hook-form";

import { FormValues } from "../salary-modal";
import { DataTable } from "./salary-components-table/data-table";
import { columns } from "./salary-components-table/columns";

export const SalaryComponents = () => {
  const form = useFormContext<FormValues>();

  const {
    fields: componentFields,
    append: appendComponent,
    remove: removeComponent,
    update: updateComponent,
  } = useFieldArray({
    name: "components",
    control: form.control,
  });

  return (
    <div className="flex flex-col">
      <h2 className="text-lg font-medium">Components</h2>

      <DataTable
        data={componentFields}
        columns={columns}
        appendComponentRow={appendComponent}
        updateComponentRow={updateComponent}
        removeComponentRow={removeComponent}
      />
    </div>
  );
};
